import { render, staticRenderFns } from "./DirectoryPage.vue?vue&type=template&id=4dd35968&scoped=true&"
import script from "./DirectoryPage.vue?vue&type=script&lang=ts&"
export * from "./DirectoryPage.vue?vue&type=script&lang=ts&"
import style0 from "./DirectoryPage.vue?vue&type=style&index=0&id=4dd35968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd35968",
  null
  
)

export default component.exports